import React, { ReactElement } from 'react';

import { SpecialistExperienceData } from '../../../2_entities';

import styles from './SpecialistAchievementsCard.module.scss';
import { ISpecialistAchievementsCardProps } from '../../../1_shared/config/interfaces/ISpecialistAchievementsCardProps';

export const SpecialistAchievementsCardMobile = ({
  spec,
  descriptions,
}: ISpecialistAchievementsCardProps): ReactElement => {
  return (
    <div className={styles.achievementsCard}>
      <SpecialistExperienceData
        spec={spec}
        descriptions={descriptions}
        isMobile
      />
    </div>
  );
};
